import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { inject } from '@vercel/analytics'
import './index.css'
import App from './App.jsx'

inject()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)

if (import.meta.env.DEV) {
  import('./lib/web-vitals').then(({ initWebVitalsDev }) => initWebVitalsDev())
} else {
  import('./lib/web-vitals').then(({ initWebVitals }) => initWebVitals())
}
